import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";

import InsideSunWest from "../Images/Inside Sun West-02.svg";
import InsideMobile from "../Images/Inside-Sun-West.png";

// import videoData from "../data/data.json";
import axios from "axios";

export default function SubFooter(props) {

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1499 },
      items: 4,
    },
    laptop: {
      breakpoint: { max: 1499, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 571 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 571, min: 0 },
      items: 1,
    },
  };

  const [videoData, setVideoData] = useState([]);
  useEffect(() => {
    const fetchJsonData = async () => {
      const response = await axios('https://swmc-cdn.s3.us-west-1.amazonaws.com/production/SWCON/data.json');
      setVideoData(response.data)
    }
    fetchJsonData();

  }, [])

  return (
    <>
      <div className="quoteWrapper mt-md-0 mt-lg-4">
        <Container className="pt-3 pb-2">
          <Row className="pt-4 justify-content-end">
            <Col md={12} lg={10} xl={10}>
              <p>
                Sun West software engineers are at the forefront of the latest
                technology trends. This is a suitable place for those who
                are excited about problem solving and the pace of emerging technologies.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-end">
            <Col xs={10} sm={6} md={5} lg={3}>
              <h4 className="mb-1">
                <strong>- Pavan Agarwal,</strong> CEO
              </h4>
              <h6>Sun West Mortgage Company, Inc.</h6>
            </Col>
          </Row>
        </Container>
      </div>
      <Image
        src={InsideSunWest}
        fluid
        className="py-3 mt-3 blueLine d-none d-sm-none d-md-block"
      />
      <Image
        src={InsideMobile}
        fluid
        className="py-3 mt-1 d-block d-sm-block d-md-none"
      />
      <Container fluid className="my-sm-2 my-md-4 videosWrapper">
        <Carousel
          aria-label="Go to next slide"
          responsive={responsive}
          arrows={true}
          swipeable={true}
          draggable={true}
          infinite={false}
          itemClass="gallery-item"
          autoPlay={false}
        >
          {videoData.map((item, i) => (
            <div key={i}>
              <div className="player-wrapper mb-3">
                <ReactPlayer
                  url={item.url}
                  width="100%"
                  height="240px"
                  controls={true}
                />
              </div>
              <h4>{item.description}</h4>
            </div>
          ))}
        </Carousel>
      </Container>
    </>
  );
}
